<template>
  <rest-list
    :payload="fetchEndpoint"
    @dataLoaded="setData($event)"
    ref="list"
    :lazy="true"
    :lazy-handler="lazyModeHandler"
    :load="load"
    row-key="id"
  >
    <template v-if="!!(data && data.length)">
      <template>
        <rest-list-column
          prop="action"
          :title="$t('CampaignChannelAnalytics_Actions_Column_Action')"
          :filter-input="false"
          :sortable="false"
        />
        <rest-list-column
          prop="variant"
          :filter-input="false"
          :title="$t('CampaignChannelAnalytics_Actions_Column_Variant')"
          :formatter="variantFormatter"
          :sortable="false"
        />
        <rest-list-column
          prop="metrics[0].value"
          :title="$t('CampaignChannelAnalytics_Actions_Column_Total')"
          :filter-input="false"
          :sortable="false"
        />
        <rest-list-column
          :filter-input="false"
          prop="metrics[1].value"
          :title="$t('CampaignChannelAnalytics_Actions_Column_Unique')"
          :sortable="false"
        />
      </template>
    </template>
  </rest-list>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestApi from '@/core/services/RestApi'
import { projectEndpoint, uuid } from '@/core/helpers'

export default {
  name: 'Interactions',
  components: { RestListColumn, RestList },
  props: {
    channel: {
      type: String,
      required: true
    },

    analyticsDateRange: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      data: [],
      treeProps: {
        hasChildren: 'id',
        children: 'id'
      },
      expandActionId: null
    }
  },

  methods: {
    variantFormatter(value) {
      return value || this.$t('CampaignChannelAnalytics_Actions_All')
    },

    load(tree, treeNode, resolve) {
      this.expandActionId = tree.id
      RestApi(this.actionEndpoint).then(({ data }) => {
        data.forEach(variant => {
          variant.id = uuid()
          variant.variant = variant.variant.id + ' – ' + variant.variant.title
        })
        resolve(data)
      })
    },

    lazyModeHandler(row) {
      return !row.variant
    },

    setData(event) {
      this.data = event
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `campaigns/${this.$route.query.id}/analytics/${this.channel}/actions`,
        params: {
          date_from: this.analyticsDateRange.date_from,
          date_to: this.analyticsDateRange.date_to
        }
      })
    },

    actionEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `campaigns/${this.$route.query.id}/analytics/${this.channel}/actions/${this.expandActionId}`,
        params: {
          date_from: this.analyticsDateRange.date_from,
          date_to: this.analyticsDateRange.date_to
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-table_2_column_1 .cell span:only-child {
  padding-left: 27px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/analytics/Interactions.vue